<template>
  <div>
    <select v-model.number="selectedId">
      <option value="">-- 뉴스 선택 --</option>
      <option
        v-for="news in newsList"
        :key="news.id"
        :value="news.id"
      >
        {{ news.title }} ({{ news.uuid }})
      </option>
    </select>

    <a
      v-show="selectedId"
      :href="`https://article21.kr/news/${selectedId}`"
      target="_blank"
      style="display: inline-block; margin-top: 4px;"
    >
      뉴스 보기
    </a>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, defineEmits } from 'vue';
import { apiClient } from '@/services/auth-header';

const newsList = ref([]);

const props = defineProps({
  contentId: { type: [String, Number], default: '' },
});
const emit = defineEmits(['update:contentId']);

const selectedId = computed({
  get: () => props.contentId,
  set: (value) => emit('update:contentId', value),
});

const fetchNewsList = async () => {
  try {
    const response = await apiClient.get('/contents/articles/news');
    newsList.value = response.data;
  } catch (error) {
    console.error('뉴스 목록 조회 실패:', error);
  }
};

onMounted(() => {
  fetchNewsList();
});
</script>

<style scoped>
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
</style>
